import type { TooltipInfo } from '@/shared/ui/uplot-chart';

type TooltipPoint = TooltipInfo['points'][number];

export const getGroupedTooltipPoints = ({
  activeSeriesId,
  points,
}: {
  activeSeriesId: string;
  points: TooltipPoint[];
}): {
  activeSeriesId: string;
  bucketValue: number;
  points: TooltipPoint[];
} => {
  const numericPoints = points.filter(
    (point) => typeof point.rawValue === 'number',
  );

  if (numericPoints.length === 0) {
    return {
      activeSeriesId,
      bucketValue: 0,
      points: [],
    };
  }

  const activePoint =
    numericPoints.find((point) => point.seriesId === activeSeriesId) ??
    numericPoints[0];
  const resolvedActiveSeriesId = activePoint.seriesId;
  const activeRawValue = activePoint.rawValue;
  const bucketValue = typeof activeRawValue === 'number' ? activeRawValue : 0;

  const samePointCandidates =
    typeof activeRawValue === 'number'
      ? numericPoints.filter((point) => point.rawValue === activeRawValue)
      : [];
  const groupedPoints =
    samePointCandidates.length > 0 ? samePointCandidates : numericPoints;

  return {
    activeSeriesId: resolvedActiveSeriesId,
    bucketValue,
    points: groupedPoints,
  };
};

export const sortTooltipPointsByIssueRank = ({
  activeSeriesId,
  issueIndexBySeriesId,
  points,
}: {
  activeSeriesId: string;
  issueIndexBySeriesId: Map<string, number>;
  points: TooltipPoint[];
}): TooltipPoint[] => {
  return [...points].sort((a, b) => {
    if (a.seriesId === activeSeriesId) return -1;
    if (b.seriesId === activeSeriesId) return 1;

    const aIndex =
      issueIndexBySeriesId.get(a.seriesId) ?? Number.MAX_SAFE_INTEGER;
    const bIndex =
      issueIndexBySeriesId.get(b.seriesId) ?? Number.MAX_SAFE_INTEGER;

    return aIndex - bIndex;
  });
};
